import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BeneficiariesService {
  public url: string;
  // public idBeneficiaryList: string;
  // public select: string;

  constructor(
    private http: HttpClient,
  ) {
    this.url = environment.url  + 'api/beneficiaries/';
    // this.idBeneficiaryList = environment.idBeneficiaryList;
    // this.select = "$select=ID,Title,Descripcion,Imagen";
  }

  public getAll(): Observable<any> {
//    return this.http.get(this.url + "_api/Web/Lists(" + this.idBeneficiaryList + ")/Items?" + this.select);
    return this.http.get(this.url);
  }
}
